<template>
  <v-dialog width="700px" persistent v-model="dialogMyAccount">
    <v-card style="padding: 35px; border-radius: 15px">
      <v-form
        @submit.prevent="handleSubmit"
        class="pessoas-redefinir-senha-form"
      >
        <v-row class="d-flex justify-between">
          <label style="font-size: 20px; font-weight: bold; color: #2d1a4c"
            >Minha conta</label
          >
        </v-row>
        <v-row class="mt-7 mb-1">
          <BaseTextField
            label="Nome"
            v-model="fields.name"
            type="text"
            class="textinput"
            name="nome"
            tabindex="1"
            @input="formErrors.nome = ''"
            :error-messages="formErrors.nome"
          ></BaseTextField>
        </v-row>
        <v-row class="mb-1">
          <v-col class="pa-0 mr-4">
            <BaseTextField
              label="E-mail"
              v-model="fields.email"
              type="text"
              class="textinput"
              name="email"
              tabindex="1"
              :rules="[v => /.+@.+\..+/.test(v) || 'E-mail deve ser válido']"
              readonly
              hint="O email não pode ser alterado."
            ></BaseTextField>
          </v-col>
          <v-col class="pa-0">
            <BaseTextField
              label="URL Personalizada"
              v-model="fields.slug"
              type="text"
              class="textinput"
              name="slug"
              tabindex="1"
              @input="formatSlug"
              :readonly="hasSlug"
              hint="A URL personalizada não poderá ser alterada."
            ></BaseTextField>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col class="pa-0 mr-4">
            <BaseTextField
              label="CPF"
              v-model="fields.cpf"
              type="text"
              class="textinput"
              name="cpf"
              tabindex="1"
              v-mask="'###.###.###-##'"
              @input="formErrors.cpf = ''"
              :error-messages="formErrors.cpf"
            ></BaseTextField>
          </v-col>
          <v-col class="pa-0">
            <BaseTextField
              label="Telefone"
              v-model="fields.phone"
              type="text"
              class="textinput"
              name="phone"
              tabindex="1"
              v-mask="'(##) #####-####'"
              @input="formErrors.phone = ''"
              :error-messages="formErrors.phone"
            ></BaseTextField>
          </v-col>
        </v-row>

        <v-row>
          <v-btn
            height="45"
            class="button button-bg rounded-lg"
            block
            tabindex="4"
            type="submit"
          >
            <span>Alterar</span>
          </v-btn>
          <v-btn
            height="45"
            class="mt-3 button-bg rounded-lg"
            block
            tabindex="5"
            color="#e0e0e0"
            @click="changeDialogMyAccount()"
          >
            <span>Cancelar</span>
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "RegisterAffiliate",
  components: {
    BaseTextField,
  },
  data() {
    return {
      fields: {
        name: "",
        email: "",
        slug: "",
        cpf: "",
        phone: "",
      },
      formErrors: {
        nome: "",
        cpf: "",
        phone: "",
      },
    };
  },
  computed: {
    ...mapGetters(["dialogMyAccount", "userInfo"]),
    hasSlug() {
      return this.userInfo?.slug?.length > 0;
    },
  },
  methods: {
    ...mapActions([
      "createAffiliate",
      "showSnackbarSuccess",
      "changeDialogMyAccount",
      "editAffiliate",
    ]),
    formatSlug() {
      this.fields.slug = this.fields.slug
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },
    handleSubmit() {
      if (this.fields.name.length < 1) {
        this.formErrors.nome = "Este campo não deve estar vazio";
        return;
      }
      if (this.fields.cpf.length < 1) {
        this.formErrors.cpf = "Este campo não deve estar vazio";
        return;
      }
      if (this.fields.phone.length < 1) {
        this.formErrors.phone = "Este campo não deve estar vazio";
        return;
      }
      this.editAffiliate({
        id: this.userInfo.idafiliado,
        nome: this.fields.name,
        telefone: this.fields.phone,
        cpf: this.fields.cpf,
        slug: this.fields.slug,
      }).then(() => {
        this.changeDialogMyAccount();
      });
    },
  },
  watch: {
    "$store.getters.userInfo"() {
      this.fields.name = this.userInfo.nome;
      this.fields.email = this.userInfo.email;
      this.fields.slug = this.userInfo.slug;
      this.fields.cpf = this.userInfo.cpf;
      this.fields.phone = this.userInfo.telefone;
    },
  },
  mounted() {
    this.fields.name = this.userInfo.nome;
    this.fields.email = this.userInfo.email;
    this.fields.slug = this.userInfo.slug;
    this.fields.cpf = this.userInfo.cpf;
    this.fields.phone = this.userInfo.telefone;
  },
};
</script>

<style scoped></style>
